// @flow

import stores from 'stores';

export default (id: string) => {
  return stores.parcelsStore.searchReturnById(id);
};
